import { render, staticRenderFns } from "./DigitalSignageTv.vue?vue&type=template&id=0c16a3c0&scoped=true"
import script from "./DigitalSignageTv.ts?vue&type=script&lang=ts&external"
export * from "./DigitalSignageTv.ts?vue&type=script&lang=ts&external"
import style0 from "./DigitalSignageTv.scss?vue&type=style&index=0&id=0c16a3c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16a3c0",
  null
  
)

export default component.exports